<template >
  <div class="container shape-container d-flex">
    <div>
      <CoolLightBox :items="limages" :index="imgindex" @close="imgindex = null">
      </CoolLightBox>
    </div>
    <div class="row">
      <div class="col-md-6 col-sm-12 vshide">
        <!-- <button type="button" class="btn btn-sm cool">Our top picks</button>
        <button type="button" class="btn btn-sm cool">Couple Friendly</button>
        <button type="button" class="btn btn-sm cool">with Combo</button> -->
        <!-- <button type="button" class="btn btn-sm cool">Lowest Price first</button>
        <button type="button" class="btn btn-sm cool">Star rating and price</button>-->
        <!-- <button type="button" class="btn btn-sm cool">Top reviewed</button> -->
      </div>
      <div class="col-md-3 col-sm-12 vshide">
        <multiselect
          :multiple="false"
          placeholder="Select hotel"
          v-model="filters.hotel"
          :options="hoteloptions"
          label="hotel_name"
          open-direction="bottom"
          :searchable="true"
          :loading="isHotelsFilterLoading"
          track-by="hotel_id"
          :internal-search="false"
          :clear-on-select="false"
          :close-on-select="true"
          :options-limit="300"
          :limit="3"
          :limit-text="limitText"
          :max-height="600"
          :show-no-results="true"
          :hide-selected="true"
          @search-change="getHotelsSearch"
          @select="gotohotel"
        ></multiselect>
        <!-- <multiselect
          :multiple="false"
          placeholder="Enter location name"
          v-model="locationvalue"
          :options="locationoptions"
        ></multiselect> -->
      </div>
      <div class="col-md-3 col-sm-12 vshide">
        <multiselect
          :multiple="false"
          placeholder="Sort By"
          v-model="filters.sortvalue"
          :options="sortoptions"
        ></multiselect>
      </div>

      <div class="cmt50"></div>
      <div class="col-md-2 col-sm-12 mt-2 box filterbox">
        <h5 class="mb-3">Select Filters</h5>
        <h5></h5>
        <div class="Filter mb-3">
          <div class="form-check">
            <input
              class="form-check-input"
              type="checkbox"
              v-model="filters.mainfilter"
              value="toppicks"
              id="toppicks"
            />
            <label class="form-check-label" for="toppicks">Our Top Picks</label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="checkbox"
              v-model="filters.mainfilter"
              value="cfriendly"
              id="cfriendly"
            />
            <label class="form-check-label" for="cfriendly"
              >Couple Friendly</label
            >
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="checkbox"
              v-model="filters.mainfilter"
              value="withcombo"
              id="withcombo"
            />
            <label class="form-check-label" for="withcombo">With Combo</label>
          </div>
        </div>
        <h5 class="mt-2 mb-3">Star rating</h5>
        <div class="Filter mt-2">
          <div class="form-check">
            <input
              v-model="filters.stars"
              class="form-check-input"
              type="checkbox"
              value="5"
              id="stars5"
            />
            <label class="form-check-label" for="stars5">5 Stars</label>
          </div>
          <div class="form-check">
            <input
              v-model="filters.stars"
              class="form-check-input"
              type="checkbox"
              value="4"
              id="stars4"
            />
            <label class="form-check-label" for="stars4">4 Stars</label>
          </div>
          <div class="form-check">
            <input
              v-model="filters.stars"
              class="form-check-input"
              type="checkbox"
              value="3"
              id="stars3"
            />
            <label class="form-check-label" for="stars3">3 Stars</label>
          </div>
          <div class="form-check">
            <input
              v-model="filters.stars"
              class="form-check-input"
              type="checkbox"
              value="2"
              id="stars2"
            />
            <label class="form-check-label" for="stars2">2 Stars</label>
          </div>
          <div class="form-check">
            <input
              v-model="filters.stars"
              class="form-check-input"
              type="checkbox"
              value="1"
              id="stars1"
            />
            <label class="form-check-label" for="stars1">1 Stars</label>
          </div>
        </div>
        <h5 class="mt-2">Price Range</h5>
        <div class="Filter">
          <range-slider
            class="slider"
            min="1000"
            max="20000"
            step="10"
            v-model="priceSliderValueMin"
            @change="getHotels"
          ></range-slider>
          <!-- <range-slider
            class="slider"
            :min="priceSliderValueMin"
            max="20000"
            step="200"
            v-model="priceSliderValueMax"
            @change="getHotels"
          ></range-slider> -->
          <div>₹ {{ priceSliderValueMin }} - {{ priceSliderValueMax }}</div>
        </div>

        <h5 class="mt-2">Review score</h5>
        <div class="score">
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              v-model="filters.reviewscore"
              value="superb"
              id="Superb"
            />
            <label class="form-check-label" for="Superb"> Superb :4.5+ </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              v-model="filters.reviewscore"
              value="verygood"
              id="veryGood"
            />
            <label class="form-check-label" for="veryGood">
              Very Good :4+
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              v-model="filters.reviewscore"
              value="good"
              id="Good"
            />
            <label class="form-check-label" for="Good"> Good :3+ </label>
          </div>
        </div>
        <!-- <a class="btn btn-primary text-white mt-5">Filter</a> -->
      </div>
      <div class="col-md-10 col-sm-12 mobile-row">
        <div v-if="!allhotels || !allhotels.length">
          <h4 class="alert alert-warning">
            No hotels found for your search query, please try with different
            terms
          </h4>
        </div>
        <div v-if="isloading">
          <h4 class="alert alert-info">Please Wait...</h4>
        </div>
        <div v-bind:key="hotel.hotel_id" v-for="hotel in allhotels">
          <div
            class="row hotel-panel hotelslist"
            v-if="
              hotel.hasroom != false &&
              hotel.room_start_date <= checkindate &&
              hotel.room_end_date >= checkindate &&
              hotel.room_start_date <= checkoutdate &&
              hotel.room_end_date >= checkoutdate
            "
          >
            <div class="col-md-3 col-sm-12 hotel-images">
              <!-- <img v-lazy="hotel.hotel_image" alt="hotel_Name" class="hotelimg" /> -->
              <carousel
                v-if="
                  hotel &&
                  hotel.hotel_images &&
                  hotel.hotel_images.split(',').length > 0
                "
                :navigationEnabled="true"
                :paginationEnabled="true"
                :scrollPerPage="true"
                :perPage="1"
                :perPageCustom="[
                  [480, 1],
                  [768, 1],
                  [1199, 1],
                ]"
                :autoplay="false"
                :loop="false"
                :interval="10000"
                :speed="720"
              >
                <slide
                  v-bind:key="himgindex"
                  v-for="(himg, himgindex) in hotel.hotel_images
                    .split(',')
                    .slice(0, 5)"
                >
                  <img
                    v-lazy="'https://hotellele.com/fcrm/uploads/hotels/' + himg"
                    class="hotelimg"
                    @click="showlightbox(himgindex, hotel.hotel_images_full)"
                  />
                </slide>
              </carousel>
              <span class="reviews view-xs"> {{ hotel.own_rating }} / 5</span>
              <span class="displayword view-xs">Our Ratings</span>
            </div>
            <div class="col-md-6 col-sm-12 hotel-detail">
              <h5>
                <span class="fontresize">{{ hotel.hotel_name }}</span>
                <span>
                  &nbsp;
                  <i
                    v-for="index in Number(hotel.hotel_stars)"
                    v-bind:key="index"
                    class="fa fa-star fa-xs starsize"
                    aria-hidden="true"
                  ></i>
                </span>
              </h5>
              <h5>
                <!-- <i class="fa fa-map-marker" aria-hidden="true"></i> -->
                {{ hotel.hotel_locality }} , {{ hotel.city_name }}
                <span class="reviews view-pc"> {{ hotel.own_rating }} / 5</span>
                <br />
                <span class="displayword view-pc">Our Ratings</span>
              </h5>
              <div class="amlistbox">
                <div
                  v-html="$options.filters.csvtags(hotel.hotel_amenities)"
                  class="amlist view-pc mb-3"
                ></div>
              </div>
              <h6 class="mt-1 mb-1">Hotel Highlights</h6>
                <div class="dataofinclud highlights">
                  <small
                    v-bind:key="highs"
                    v-for="(highs, hindex) in hotel.hotel_highlights.split(',')"
                    ><span v-if="hindex < 5"
                      ><i class="fa fa-check"></i> {{ highs }}
                    </span></small>
                </div>
              <p class="remake">{{ hotel.remark_hotel_detail_page }}</p>
            </div>
            <div class="col-md-3 col-sm-12 hotel-price">
              
              <h4 class="price">
                <span hidden id="pertotalroom" v-if="totalrooms>=1">
                  {{totalrooms =
                      Math.ceil(maxguest / hotel.room_total_person.substring(0, 1))}}
              </span>
                <small class="saveamt" v-if="hotel.starting_price_gross > 0"
                  >Save <span>&#8377;</span>
                  {{
                    hotel.starting_price_gross *
                    totalrooms -
                    hotel.starting_price *
                    totalrooms
                  }}

                  <span class="discount"
                    >{{
                      Math.round(
                        ((hotel.starting_price_gross - hotel.starting_price) /
                          hotel.starting_price) *
                          100,
                        2
                      )
                    }}&nbsp;%</span
                  ></small
                >
                <br />
                <small class="fullamt" v-if="hotel.starting_price_gross > 0">
                  <s>
                    <span>&#8377;</span>
                    {{
                      hotel.starting_price_gross *
                      totalrooms
                    }}
                  </s>
                  <br />
                </small>
                <span class="saleAmt">
                  <span>&#8377;</span>
                  <strong class="pernight">
                    {{
                      hotel.starting_price *
                      totalrooms
                    }}
                  </strong>
                  <p class="pricenight">
                    Per Night for
                    {{totalrooms}}
                    Rooms
                  </p>
                </span>
              </h4>
              <!-- Math.ceil(maxguest / hotel.room_total_person.substring(0, 1)) -->

              <div class="lastsection">
                <RouterLink
                  class="btn btn-primary chooseroom"
                  :to="
                    'hoteldetail?hotelid=' +
                    hotel.hotel_id +
                    '&tr=' +
                    totalrooms
                  "
                  >Choose Room</RouterLink
                >
              </div>
            </div>
          </div>

          <div
            v-else-if="
              hotel.room_start_date <= checkindate &&
              hotel.room_end_date <= checkindate &&
              hotel.room_start_date <= checkoutdate &&
              hotel.room_end_date <= checkoutdate
            "
          >
            <h4 class="alert alert-warning">
              <!-- No hotels found for your search query, please try with different
              terms -->
              No Hotels found on this Dates
            </h4>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { APIURLS } from "../../api/constants";
import RangeSlider from "vue-range-slider";
import "vue-range-slider/dist/vue-range-slider.css";
import CoolLightBox from "vue-cool-lightbox";
import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";
import moment from "moment";

export default {
  components: {
    RangeSlider,
    CoolLightBox,
  },
  props: {
    cnames: String,
    cids: String,
    cdates: String,
    cguests: String,
    ctravfor: String,
    stars: String,
    filtersprop: Array,
  },
  data() {
    return {
      allhotels: null,
      priceSliderValueMin: 1000,
      priceSliderValueMax: 20000,
      sortoptions: ["Lowest Price", "Highest Price"],
      isloading: true,
      locationoptions: ["Lowest Price", "Highest Price"],
      locationvalue: "",
      imgindex: null,
      limages: [],
      isHotelsFilterLoading: false,
      totalrooms: localStorage.getItem("trooms"),
      maxguest: localStorage.getItem("totalguest"),
      checkoutdate: localStorage.getItem("checkout"),
      checkindate: localStorage.getItem("checkin"),
      //tempvalue:0,
      filters: {
        sortvalue: "",
        stars: [],
        mainfilter: [],
        reviewscore: null,
        hotel: null,
      },
      hoteloptions: [
        {
          id: "0",
          name: "Please type slowly and select hotels",
        },
      ],
    };
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        this.getHotels();
      },
    },
    // totalrooms: {
    //   deep: true,
    //   handler() {
    //     localStorage.setItem("trooms", this.totalrooms);
    //   },
    // },
  },
  methods: {
    gotohotel(selectionOption, id) {
      this.$router.push({
        path: "hoteldetail",
        query: { hotelid: selectionOption.hotel_id },
      });
    },
    showlightbox(index, arr) {
      this.limages = null;
      this.limages = arr.split(",");
      this.imgindex = index;
    },
    filterTags(v) {
      return csvtags(v);
    },
    limitText(count) {
      return `and ${count} other hotels`;
    },
    clearHotelSearch() {
      this.hoteloptions = [];
    },
    getHotelsSearch(query) {
      // console.log('first');
      this.clearHotelSearch();
      this.isHotelsFilterLoading = true;
      var urltogo = APIURLS.GET_HOTEL_SEARCH + "?q=" + query;
      axios.get(urltogo).then((response) => {
        this.hoteloptions = response.data;
        this.isHotelsFilterLoading = false;
      });
    },
    getHotels() {
      this.isloading = true;
      axios
        .get(APIURLS.GET_HOTELS, {
          params: {
            cityids: this.cids,
            citynames: this.cnames,
            dates: this.cdates,
            guests: this.cguests,
            travfor: this.ctravfor,
            stars: this.stars,
            filters: this.filters,
            pricemin: this.priceSliderValueMin,
            pricemax: this.priceSliderValueMax,
            totalguest: localStorage.getItem("totalguest"),
            checkindate: this.checkindate,
            checkoutdate: this.checkoutdate,
            combohotel: localStorage.getItem("combohotel"),
          },
        })
        .then((response) => {
          this.allhotels = response.data;
          this.isloading = false;
          // console.log(response.data);
        })
        .catch((err) => {
          this.isloading = false;
        });
    },
    handleTasks(task) {
      // Do what you want with the selected objects:
    },
  },
  created() {
    this.getHotels();
  },
};
</script>

<style scoped>
.remake {
  margin-top: 1em;
  color: #083578;
  font-weight: 500;
  font-size: 1.1em;
}
.filterbox {
  background: #ffffff;
}
.cmt50 {
  margin-top: 50px;
}
.hotel-panel {
  margin-bottom: 8%;
}
.hotelimg {
  min-width: 100%;
  max-width: 100%;
  min-height: 135px;
  max-height: 135px;
}

.hotelsdetail {
  background-color: #cccccc;
}
.hotelslist {
  background-color: #cccccc38;
  margin-bottom: 0.5rem;
  box-sizing: border-box;
  transition: box-shadow 0.3s;
  border-radius: 10px;
  border: 1px solid rgb(226, 228, 248);
  background: #fff;
  float: left;
  width: 100%;
  margin-bottom: 1rem;
}
.hotelslist:hover {
  box-shadow: 0 0 11px rgb(100 110 223 / 10%);
}
.starsize {
  width: 0.7rem;
  font-size: 0.7rem;
}
.fontresize {
  font-size: 1.15rem;
}
.cool {
  padding: 0.5rem 1.2rem;
  margin-bottom: 3rem;
  color: #fff;
  background-color: #6773e6;
  font-size: 0.9rem;
}
.hotel-detail > h3 {
  font-weight: 800;
  color: #000;
}
.displayword {
  position: absolute;
  float: right;
  right: 2%;
  font-size: 0.7rem;
  color: #000;
  background-color: #fff;
  margin-top: 0.6em;
}

.reviews {
  position: absolute;
  background-color: #6773e6;
  color: #fff;
  border-radius: 10px;
  padding: 1%;
  font-size: 1rem;
  font-weight: 600;
  float: right;
  right: 2%;
}

.hotel-images {
  padding-left: 1.5em;
}
.hotel-images {
  padding: 1em;
}

.hotel-detail {
  padding: 2rem 0 0 2rem;
}
.dataofinclud {
  font-size: 0.9em;
  color: #172b4d;
  display: inline-grid;
}
.hotel-price {
  background-color: #f5f5f5;
  border-left: 1px #e6e6e6 solid;
  padding: 2rem 0 0 1rem;
}
.lastsection {
  margin-bottom: 0.3rem;
}
.included > h6 {
  text-transform: uppercase;
}
.btn-primary:hover {
  -webkit-box-shadow: 0 0 11px rgb(82 80 80 / 54%);
  box-shadow: 0 0 11px rgb(82 80 80 / 54%);
  color: #172b4d;
  background-color: #f7dc69;
  background-image: unset;
  border: 1px solid #f7dc69;
}
.saveamt {
  font-size: 1rem;
  color: red;
}
.fullamt {
  font-size: 0.8em;
  color: #083578;
  font-weight: 600;
}
.saleAmt {
  font-size: 2rem;
  color: #6773e6;
}
.pricenight {
  font-size: 0.9rem;
  color: #083578;
  font-weight: 800;
}

.discount {
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-text-size-adjust: 100%;
  position: absolute;
  display: inline-block;
  background: #6773e6;
  width: 50px;
  height: 22px;
  line-height: 20px;
  font-weight: bold;
  color: #fff;
  text-align: center;
  border-radius: 4px;
  padding: 0 10px;
  margin-left: 9%;
  margin-top: 4%;
  font-size: 0.9rem;
}
.discount:after {
  content: " ";
  height: 17px;
  width: 17px;
  background: #6773e6;
  position: absolute;
  top: 2px;
  left: -6px;
  border-radius: 4px;
  -moz-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
}
.discount:before {
  content: "";
  width: 5px;
  height: 5px;
  background: #fff;
  position: absolute;
  top: 8px;
  left: 0px;
  z-index: 1;
  border-radius: 10px;
}

.view-pc {
  display: inline;
}
.view-xs {
  display: none;
}

.VueCarousel-pagination {
  margin: 0 !important;
  position: absolute !important;
  bottom: 0.5% !important;
}
.VueCarousel-dot-container {
  margin-top: 0% !important;
}
.VueCarousel-dot {
  padding: 5px !important;
}

@media (min-width: 300px) and (max-width: 769px) {
  /* .row{
    margin: 0;
  } */
  .mobile-row {
    padding: 0;
    width: 90%;
    margin: 0 auto;
  }
  .VueCarousel {
    height: 100%;
    max-height: 250px;
  }
  .box,
  .vshide {
    display: none;
  }
  .hotelimg {
    max-width: 100%;
    max-height: 100%;
    background-size: cover;
  }
  .hotelslist {
    width: 100%;
    margin: 0 auto;
  }
  .hotel-detail {
    margin-top: 2rem;
  }
  .hotel-detail,
  .hotel-images,
  .hotel-price {
    padding: 0.5rem 0.5rem 0 0.5rem;
  }
  .hotel-detail {
    margin-top: 0rem;
  }
  .hotel-detail > h3 > span {
    font-size: 1.8rem;
    font-weight: 100;
  }
  .view-pc {
    display: none;
  }
  .view-xs {
    display: block;
  }

  .reviews {
    float: left;
    left: 2%;
    border-top-left-radius: 2%;
    border-bottom-left-radius: 2%;
    width: 35%;
    bottom: 2%;
    font-size: 0.9rem;
  }
  .displayword {
    color: #fff;
    float: left;
    left: 12.8%;
    bottom: 3.9%;
    font-size: 0.6rem;
    background-color: transparent;
    width: 17%;
  }
  .lastsection {
    position: unset;
    padding-bottom: 1rem;
  }
  .discount {
    margin-top: 0%;
    margin-left: 18%;
    font-size: 0.7rem;
    width: 35px;
  }
  .hotel-detail > h3 > span {
    font-size: 1.2rem;
  }
  h4 {
    font-size: 1rem;
  }
  h6 {
    font-size: 0.8rem;
    width: 50%;
  }

  .price {
    position: absolute;
    float: right;
    top: 2%;
    right: 1%;
  }
  .saleAmt {
    font-size: 1rem;
  }
  .pricenight::before {
    content: "\a";
    white-space: pre;
  }
  .pricenight {
    line-height: 10px;
  }
  .chooseroom {
    margin: 0 auto;
    display: block;
    margin-top: 3rem;
    width: 50%;
  }
}
</style>
<style>
.VueCarousel-pagination {
  position: absolute;
  top: 50%;
}
.amlistbox {
  width: 25em;
}
.amtag {
  padding-top: 0.7em;
  font-size: 1em;
  color: #6773e6;
  margin-bottom: 0.1rem;
  margin-right: 0.6em;
  display: inline-flex;
}
.amtag2 {
  display: inline-flex;
}
.amtag::before {
  font-family: "FontAwesome";
  content: "\F00C";
  display: inline-block;
  padding-right: 3px;
  vertical-align: middle;
  font-weight: 900;
}

.amtag:after {
  content: ",";
  margin-left: 0.4em;
}
.amlist {
  list-style: none;
}
.hoteldesc {
  margin-top: 1em !important;
}
.hotelimg {
  cursor: pointer;
}
.range-slider-knob {
  display: block;
  position: absolute;
  top: 50%;
  left: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 0.9rem;
  width: 0.9rem;
  border: 1px solid #083578;
  border-radius: 50%;
  background-color: #083578;
  -webkit-box-shadow: 1px 1px rgb(0 0 0 / 20%);
  box-shadow: 1px 1px rgb(0 0 0 / 20%);
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  cursor: pointer;
}
.range-slider-fill {
  background-color: #f7dc69;
}
.highlights{
  display: inline !important;
}
.hotel-images{
  align-self: center;
}
</style>